export type PaymentStatus = 'pending' | 'uploaded' | 'verified' | 'rejected'

export type PaymentMode = 'upi' | 'cash' | 'credit' | 'bank_transfer' | 'cheque'

export const PAYMENT_MODE_LABELS: Record<PaymentMode, string> = {
  upi: 'UPI',
  cash: 'Cash',
  credit: 'Credit',
  bank_transfer: 'Bank Transfer',
  cheque: 'Cheque',
}

export interface PaymentBuyer {
  id: string
  name: string
  businessName?: string
  phone?: string
  email?: string
  role?: string
}

export interface PaymentRecord {
  id: string
  orderId: string
  paymentMode: PaymentMode
  qrRef?: string
  screenshotUrl?: string
  amount: number
  status: PaymentStatus
  verifiedBy?: string
  verifiedAt?: string
  createdAt: string
  updatedAt: string
  buyer?: PaymentBuyer
}

export interface PaymentDetailRecord extends PaymentRecord {
  buyerAddress?: string
}
